<template>
    <div class="card-box">
        <div class="title-wrap">
            <div class="title" v-html="title"></div>
        </div>
        <div class="list-wrap">
            <ul>
                <li v-for="(item, idx) in list" :key="idx" v-html="item"></li>
            </ul>
        </div>
        <div class="app-down-wrap" v-if="links">
            <button>
                <a :href="links[0]" target="_blank">
                    <img src="@/assets/google_play_down.png" alt="" />
                </a>
            </button>
            <button>
                <a :href="links[1]" target="_blank">
                    <img src="@/assets/app_store_down.png" alt="" />
                </a>
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {},
        list: {},
        links: {},
    },
};
</script>
<style lang="scss" scoped>
.card-box {
    background: var(--gray2);
    padding: 60px 50px;
    width: 100%;
    flex: 1 0 370px;
    height: 452px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    min-width: 0;

    .title {
        font-family: 'Pretendard', sans-serif;
        font-weight: 700;
        color: var(--black1);
        font-size: 28px;
        line-height: 1.4;
        letter-spacing: -0.025em;
        margin-bottom: 25px;
        @media screen and (max-width: 768px) {
            font-size: 24px;
        }
    }

    .list-wrap ul li {
        position: relative;
        list-style: none;
        letter-spacing: -0.025em;
        padding-left: 12px;
        color: var(--black3);
        font-weight: 400;
        font-family: 'Pretendard', sans-serif;
        word-break: keep-all;

        & + li {
            margin-top: 10px;
        }

        &::after {
            position: absolute;
            content: '';
            width: 4px;
            height: 4px;
            background: #ccc;
            top: calc(1ch - 2px);
            left: 0;
        }
    }
    .app-down-wrap {
        display: flex;
        margin-top: auto;
        gap: 9px;
        button {
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        @media screen and (max-width: 768px){
            margin-top: 25px;
        }
    }
}
</style>
